import React, { useState } from 'react';
import { Box, Typography, FormControl, FormControlLabel, Radio, RadioGroup, Card, CardContent, Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, } from '@mui/material';
import { Email as EmailIcon, Security as SecurityIcon, Close as CloseIcon, } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

interface EmailMethodSelectionProps {
  open: boolean;
  onClose: () => void;
  onSelectMethod: (method: 'imap' | 'oauth') => void;
}

const EmailMethodSelection: React.FC<EmailMethodSelectionProps> = ({ open, onClose, onSelectMethod }) => {
  const theme = useTheme();
  const [selectedMethod, setSelectedMethod] = useState<'imap' | 'oauth' | null>(null);

  const handleMethodSelect = (method: 'imap' | 'oauth') => {
    setSelectedMethod(method);
    onSelectMethod(method);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        Choose Email Setup Method
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Select how you want to connect your email for automatic ticket creation.
        </Typography>

        <FormControl component="fieldset" fullWidth>
          <RadioGroup
            value={selectedMethod || ''}
            onChange={(e) => setSelectedMethod(e.target.value as 'imap' | 'oauth')}
          >
            {/* <Card
              sx={{
                mb: 2,
                border: selectedMethod === 'imap' ? `2px solid ${theme.palette.primary.main}` : '1px solid #e0e0e0',
                cursor: 'pointer'
              }}
              onClick={() => setSelectedMethod('imap')}
            >
              <CardContent>
                <FormControlLabel
                  value="imap"
                  control={<Radio />}
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <EmailIcon color="primary" />
                      <Box>
                        <Typography variant="subtitle1" fontWeight="bold">
                          IMAP (Traditional)
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Direct server connection with username/password
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          • Simple setup with email credentials<br />
                          • Works with most email providers<br />
                          • Requires app passwords for Gmail
                        </Typography>
                      </Box>
                    </Box>
                  }
                  sx={{ width: '100%', m: 0 }}
                />
              </CardContent>
            </Card> */}

            <Card
              sx={{
                mb: 2,
                border: selectedMethod === 'oauth' ? `2px solid ${theme.palette.primary.main}` : '1px solid #e0e0e0',
                cursor: 'pointer'
              }}
              onClick={() => setSelectedMethod('oauth')}
            >
              <CardContent>
                <FormControlLabel
                  value="oauth"
                  control={<Radio />}
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <SecurityIcon color="primary" />
                      <Box>
                        <Typography variant="subtitle1" fontWeight="bold">
                          OAuth (Secure)
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Secure token-based authentication
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          • More secure authentication<br />
                          • No password storage<br />
                          • Supports Gmail, Outlook, Yahoo
                        </Typography>
                      </Box>
                    </Box>
                  }
                  sx={{ width: '100%', m: 0 }}
                />
              </CardContent>
            </Card>
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={() => selectedMethod && handleMethodSelect(selectedMethod)}
          disabled={!selectedMethod}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailMethodSelection;
